import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import { Accordion, Card, Dropdown, Modal } from "react-bootstrap";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import Radio from "@material-ui/core/Radio";
import { useSelector, useDispatch } from "react-redux";

import {
  Background,
  MainContainer,
  Title,
  SubTitle,
  InputQuantity,
  TextQuantity,
  SelectProduct,
  CardHeader,
  ContainerButton,
  BackIcon,
  AlignDropdownBranch,
  DivisionQuantityButtons,
} from "~/pages/Order/styles";
import { ImgTitle } from "~/pages/Order/styles";
import api from "~/services/api";
import back from "~/assets/images/arrow.svg";
import { OutlineGrayButton } from "~/components/layout/Buttons";
import IconProduct from "~/components/layout/IconProduct";
import Loading from "~/components/layout/Loading";
import HeaderMobile from "~/components/layout/HeaderOld";
import { analytics, logEvent }  from "~/services/firebaseConfig";
import p13Cinza from "~/assets/images/botijao-p13-cinza.svg";

export default function EditOrder({ desktop, idOrder }) {
  const history = useHistory();
  const dispatch = useDispatch();

  const items = useSelector((state) => state.orderReducer.items);
  const products = useSelector((state) => state.orderReducer.products);
  const selectedBranch = useSelector(
    (state) => state.orderReducer.selectedBranch
  );

  const [product, setProduct] = useState("");
  const [lastProduct, setLastProduct] = useState("");
  const [quantity, setQuantity] = useState(0);
  const [expand, setExpand] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState("");
  const [loadingPage, setLoadingPage] = useState(true);
  const [zero, setZero] = useState(false);
  const [itemId, setItemId] = useState(0);
  const openModal = useSelector((state) => state.orderReducer.modalEditOpen);

  function editItem(item, index) {
    dispatch({ type: "EDIT_ITEM", item, index });
  }

  function addProducts(products) {
    dispatch({ type: "ADD_PRODUCT", products });
  }

  function getProducts() {
    if (product === "") {
      const header = {
        "Content-Type": "application/json",
        access_token: localStorage.getItem("access_token"),
      };
      const parameters = {
        method: "POST",
        headers: header,
      };
      const url = `/residential/store/v1/stores/${localStorage.getItem(
        "storeId"
      )}/business-characteristics`;
      api
        .get(url, parameters)
        .then((res) => {
          addProducts(
            res.data.supplyBranches[selectedBranch ? selectedBranch : 0]
              .products
          );
          setProduct(
            res.data.supplyBranches[selectedBranch ? selectedBranch : 0]
              .products[0]
          );
          getProductToEdit(items);
          setLoadingPage(false);
        })
        .catch((err) => {
          if (err.response) {
            const message = err.response.data.message;
            toast.error(message);
          }
          setLoadingPage(false);
        });
    }
  }

  useEffect(() => {
    getProducts();
  }, []);

  async function getProductToEdit(products) {
    let id = null;
    if (desktop || window.screen.width > 768) {
      setItemId(idOrder);
      id = idOrder;
    } else {
      let search = window.location.search;
      let params = new URLSearchParams(search);
      id = await params.get("id");
      id = parseInt(id);
      setItemId(id);
    }
    let selectedProduct;
    products.map((item, index) => {
      if (index === (id === 0 ? id : id - 1)) {
        selectedProduct = item;
      }
    });
    const { code, name } = selectedProduct.product;

    let element = { code, name };
    setLastProduct(element)
    setProduct(element);
    setSelectedProduct(selectedProduct);
    setQuantity(selectedProduct.quantity);
  }

  async function handleUpdateProduct(productItem) {
    let possible = true;
    let equal = 0;
    if (quantity > 0) {
      if (items.length > 0) {
        items.map((item) => {
          if (lastProduct.name !== productItem.product.name &&
          item.product.name === productItem.product.name) {
            equal++;
          }
        });
      }
      if (equal >= 1) {
        toast.error("Não é possível inserir produtos duplicados");
        possible = false;
      }
      if (possible && productItem !== "") {
        const item = {
          id: productItem.id,
          product: productItem.product,
          quantity: productItem.quantity,
        };
        let sendIndex = 0;
        items.map((element, index) => {
          if (element.id === item.id) {
            sendIndex = index;
          }
        });
        await editItem(item, sendIndex);
          history.push("/criar-pedido");        
      }
    }
  }

  const CustomSelect = React.forwardRef(({ children, onClick }, ref) => {
    return (
      <SelectProduct
        ref={ref}
        onClick={(event) => {
          event.preventDefault();
          onClick(event);
          expand ? setExpand(false) : setExpand(true);
        }}
      >
        <IconProduct productName={children} />
        <span>{children}</span>
        {expand ? <ExpandLessIcon /> : <ExpandMoreIcon />}
      </SelectProduct>
    );
  });

  return (
    <>
      {desktop || window.screen.width > 768 ? (
        <Modal
          show={openModal}
          onHide={() => {
            dispatch({ type: "MODAL_EDIT", modalEdit: false });
          }}
          centered
          className="employee-modal"
        >
          <Modal.Body style={{ padding: "0 35px" }}>
            <Background>
              {loadingPage ? (
                <>
                  <HeaderMobile />
                  <BackIcon
                    onClick={() =>
                      dispatch({ type: "MODAL_EDIT", modalEdit: false })
                    }
                  >
                    <img src={back} alt="Ícone para voltar" />
                  </BackIcon>
                  <Loading />
                </>
              ) : (
                <>
                  <HeaderMobile />
                  <BackIcon
                    onClick={() =>
                      dispatch({ type: "MODAL_EDIT", modalEdit: false })
                    }
                  >
                    <img src={back} alt="Ícone para voltar" />
                  </BackIcon>
                  <MainContainer>
                    <Title>
                      <ImgTitle src={p13Cinza} alt="Ícone butijão" />
                      Pedido de Abastecimento
                    </Title>
                    <SubTitle>
                      Escolha o tipo de botijão para abastecimento
                    </SubTitle>
                    <Accordion defaultActiveKey="0">
                      <Card.Header style={CardHeader}>
                        Item - {itemId}
                      </Card.Header>
                      <Card>
                        <Card.Body>
                          <Dropdown className="products">
                            <Dropdown.Toggle
                              as={CustomSelect}
                              id="dropdown-custom-components"
                            >
                              {product.name}
                            </Dropdown.Toggle>

                            <Dropdown.Menu style={{ width: "100%" }}>
                              {products.map((element, index) => {
                                return (
                                  <Dropdown.Item
                                    key={element.code}
                                    eventKey={`${element.code}`}
                                    onClick={() => {
                                      setProduct(element);
                                    }}
                                    style={AlignDropdownBranch}
                                  >
                                    <Radio
                                      color="primary"
                                      checked={product.name === element.name}
                                    />
                                    <span>{element.name}</span>
                                    <span style={{ margin: "0 .5rem" }}>
                                      <IconProduct productName={element.name} />
                                    </span>
                                  </Dropdown.Item>
                                );
                              })}
                            </Dropdown.Menu>
                          </Dropdown>
                          <TextQuantity>Escolha a quantidade</TextQuantity>
                          <InputQuantity
                            type="number"
                            value={quantity === null || quantity < 0 ? 0 : quantity}
                            onFocus={() =>
                                logEvent(analytics, 'editar_campo_digitacao')
                            }
                            onChange={(event) => {
                              if (event.target.value === "") {
                                setZero(true);
                              }
                              const newValue = parseInt(event.target.value);
                              if (typeof newValue === "number") {
                                setQuantity(newValue);
                              }
                            }}
                          />
                          <DivisionQuantityButtons>
                            {
                              [1, 10, 100].map((button) => (
                                <OutlineGrayButton
                                  className={`quantity-${button}`}
                                  margin={"1rem .5rem 1rem 0"}
                                  onClick={() => {
                                    logEvent(analytics, 'abastecimento_botoes_atalho')
                                    (zero && isNaN(quantity)) || (quantity < 0)
                                      ? setQuantity(button)
                                      : setQuantity(quantity + button);
                                  }}
                                >
                                  +{button === 1 ? "01" : button}
                                </OutlineGrayButton>
                              ))
                            }
                          </DivisionQuantityButtons>
                        </Card.Body>
                      </Card>
                    </Accordion>
                    <ContainerButton>
                      <OutlineGrayButton
                        onClick={() =>
                          handleUpdateProduct({
                            id: selectedProduct.id,
                            product,
                            quantity,
                          })
                        }
                      >
                        + Atualizar item
                      </OutlineGrayButton>
                    </ContainerButton>
                  </MainContainer>
                </>
              )}
            </Background>
          </Modal.Body>
        </Modal>
      ) : (
        <Background>
          {loadingPage ? (
            <>
              <HeaderMobile />
              <BackIcon onClick={() => history.push("criar/pedido")}>
                <img src={back} alt="Ícone para voltar" />
              </BackIcon>
              <Loading />
            </>
          ) : (
            <>
              <HeaderMobile />
              <BackIcon onClick={() => history.push("criar/pedido")}>
                <img src={back} alt="Ícone para voltar" />
              </BackIcon>
              <MainContainer>
                <Title>
                  <ImgTitle src={p13Cinza} alt="Ícone butijão" />
                  Pedido de Abastecimento
                </Title>
                <SubTitle>
                  Escolha o tipo de botijão para abastecimento
                </SubTitle>
                <Accordion defaultActiveKey="0">
                  <Card.Header style={CardHeader}>Item - {itemId}</Card.Header>
                  <Card>
                    <Card.Body>
                      <Dropdown className="products">
                        <Dropdown.Toggle
                          as={CustomSelect}
                          id="dropdown-custom-components"
                        >
                          {product.name}
                        </Dropdown.Toggle>

                        <Dropdown.Menu style={{ width: "100%" }}>
                          {products.map((element, index) => {
                            return (
                              <Dropdown.Item
                                key={element.code}
                                eventKey={`${element.code}`}
                                onClick={() => {
                                  setProduct(element);
                                }}
                                style={AlignDropdownBranch}
                              >
                                <Radio
                                  color="primary"
                                  checked={product.name === element.name}
                                />
                                <span>{element.name}</span>
                                <span style={{ margin: "0 .5rem" }}>
                                  <IconProduct productName={element.name} />
                                </span>
                              </Dropdown.Item>
                            );
                          })}
                        </Dropdown.Menu>
                      </Dropdown>
                      <TextQuantity>Escolha a quantidade</TextQuantity>
                      <InputQuantity
                        type="number"
                        value={quantity}
                        onFocus={() =>
                          logEvent(analytics, 'editar_campo_digitacao')
                        }
                        onChange={(event) => {
                          if (event.target.value === "") {
                            setZero(true);
                          }
                          const newValue = parseInt(event.target.value);
                          if (typeof newValue === "number") {
                            setQuantity(newValue);
                          }
                        }}
                      />
                      <DivisionQuantityButtons>
                        {
                          [1, 10, 100].map((button) => (
                            <OutlineGrayButton
                              className={`quantity-${button}`}
                              margin={"1rem .5rem 1rem 0"}
                              onClick={() => {
                                  logEvent(analytics, 'abastecimento_botoes_atalho')
                                zero && isNaN(quantity)
                                  ? setQuantity(button)
                                  : setQuantity(quantity + button);
                              }}
                            >
                              +{button === 1 ? "01" : button}
                            </OutlineGrayButton>
                          ))
                        }
                      </DivisionQuantityButtons>
                    </Card.Body>
                  </Card>
                </Accordion>
                <ContainerButton>
                  <OutlineGrayButton
                    onClick={() =>
                      handleUpdateProduct({
                        id: selectedProduct.id,
                        product,
                        quantity,
                      })
                    }
                  >
                    + Atualizar item
                  </OutlineGrayButton>
                </ContainerButton>
              </MainContainer>
            </>
          )}
        </Background>
      )}
    </>
  );
}
